/**
 * One palette for every surface that shows or invents a colour.
 *
 * Areas can be created from four places (onboarding, Settings, the insights
 * empty state, the capture review step) and the colour is how one is recognised
 * in every rollup — a bar on `/insights`, a dot in the review list. Each
 * surface picking its own palette would mean the same area looks different
 * depending on where it happened to be born.
 *
 * Ordered by hue so the picker reads as a spectrum rather than a jumble. The
 * `name` is the accessible label for a swatch that is otherwise pure colour;
 * it is a translation key, not English shown to the user.
 */
export const AREA_COLORS = [
  { hex: "#ef4444", name: "red" },
  { hex: "#f97316", name: "orange" },
  { hex: "#f59e0b", name: "amber" },
  { hex: "#84cc16", name: "lime" },
  { hex: "#10b981", name: "emerald" },
  { hex: "#14b8a6", name: "teal" },
  { hex: "#06b6d4", name: "cyan" },
  { hex: "#3b82f6", name: "blue" },
  { hex: "#6366f1", name: "indigo" },
  { hex: "#8b5cf6", name: "violet" },
  { hex: "#ec4899", name: "pink" },
  { hex: "#64748b", name: "slate" },
] as const

/**
 * The colour for the nth area a user creates.
 *
 * Strides across the palette rather than walking it, because the palette is
 * ordered by hue: consecutive areas would otherwise come out indigo, violet —
 * two colours nobody can tell apart in a 10px dot. 5 and 12 are coprime, so the
 * stride still visits every colour before repeating one.
 */
export function nextAreaColor(existingCount: number): string {
  return AREA_COLORS[(existingCount * 5) % AREA_COLORS.length].hex
}
